import type { ExtensibleTheme } from 'ag-charts-community';
import { BASE_FONT_SIZE, FONT_SIZE_RATIO } from 'ag-charts-core';

export const organizationSeriesTheme: ExtensibleTheme<'organization'> = {
    zoom: {
        enabled: true,
        enableAxisDragging: false,
        enableAxisScrolling: false,
        enablePanning: true,
        enableScrolling: true,
        enableTwoFingerZoom: true,
        enableDoubleClickToReset: true,
        axes: 'xy',
        keepAspectRatio: true,
        anchorPointX: 'pointer',
        anchorPointY: 'pointer',
        autoScaling: { enabled: false },
        onDataChange: { strategy: 'preserveRatios' },
        minVisibleItems: 1,
        buttons: { enabled: false },
    },
    series: {
        innerSpacing: 20,
        outerSpacing: 40,
        verticalSpacing: 52,
        expander: {
            enabled: true,
            cornerRadius: { $path: '../node/cornerRadius' },
            fill: { $path: '../node/fill' },
            stroke: { $path: '../node/stroke' },
            strokeOpacity: { $path: '../node/strokeOpacity' },
            strokeWidth: { $path: '../node/strokeWidth' },
            lineDash: { $path: '../node/lineDash' },
            lineDashOffset: { $path: '../node/lineDashOffset' },
            padding: { $applyPadding: { top: 5, right: 7.5, bottom: 5, left: 7.5 } },
            text: {
                color: { $ref: 'subtleTextColor' },
                fontFamily: { $ref: 'fontFamily' },
                fontSize: { $rem: FONT_SIZE_RATIO.SMALL },
                fontStyle: 'normal',
                fontWeight: 'normal',
            },
        },
        highlight: {
            enabled: { $path: ['/highlight/enabled', true] },
            highlightedItem: {
                stroke: { $ref: 'accentColor' },
                strokeWidth: 2,
            },
        },
        link: {
            interpolation: {
                type: 'step',
                cornerRadius: 8,
            },
            lineDash: [],
            stroke: { $foregroundBackgroundMix: 0.2 },
            strokeOpacity: 1,
            strokeWidth: 1,
        },
        tooltip: {
            enabled: false,
        },
        node: {
            cornerRadius: 4,
            fill: { $foregroundBackgroundMix: 0.02 },
            padding: { $applyPadding: 8 },
            stroke: { $foregroundBackgroundMix: 0.2 },
            strokeOpacity: 1,
            strokeWidth: 1,
            image: {
                cornerRadius: 0,
                key: 'image',
                height: 50,
                position: 'top',
                spacing: 8,
                width: 50,
            },
            title: {
                color: { $ref: 'foregroundColor' },
                fontFamily: { $ref: 'fontFamily' },
                fontSize: { $rem: FONT_SIZE_RATIO.LARGE },
                fontStyle: 'normal',
                fontWeight: 'bold',
                key: 'title',
                overflowStrategy: 'ellipsis',
                padding: { $applyPadding: 0 },
                spacing: 4,
                textAlign: 'center',
                wrapping: 'on-space',
            },
            subtitle: {
                color: { $ref: 'subtleTextColor' },
                fontFamily: { $ref: 'fontFamily' },
                fontSize: { $rem: FONT_SIZE_RATIO.SMALL },
                fontStyle: 'normal',
                fontWeight: 'normal',
                key: 'subtitle',
                overflowStrategy: 'ellipsis',
                padding: { $applyPadding: 0 },
                spacing: 4,
                textAlign: 'center',
                wrapping: 'on-space',
            },
            labels: {
                $apply: {
                    color: { $ref: 'subtleTextColor' },
                    fontFamily: { $ref: 'fontFamily' },
                    fontSize: { $rem: 11 / BASE_FONT_SIZE },
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    overflowStrategy: 'ellipsis',
                    padding: { $applyPadding: 0 },
                    spacing: 4,
                    textAlign: 'center',
                    wrapping: 'on-space',
                },
            },
        },
    },
};
